import {
  User, Organization, Trait, Question, Section, Exam, ExamAssignment, ExamResult,
  QuestionBank,
} from "../types";

export const TRAITS: Trait[] = [
  
];


export const ORGS: Organization[] = [
  { id: "o1", name: "TechCorp Solutions", domain: "techcorp.com", primaryColor: "#6366f1", adminCount: 3, candidateCount: 245, status: "active", createdAt: "2024-01-15", plan: "enterprise" },
  { id: "o2", name: "Global HR Partners", domain: "globalhr.com", primaryColor: "#10b981", adminCount: 2, candidateCount: 128, status: "active", createdAt: "2024-03-20", plan: "pro" },
  { id: "o3", name: "EduAssess Institute", domain: "eduassess.org", primaryColor: "#f59e0b", adminCount: 1, candidateCount: 67, status: "inactive", createdAt: "2024-06-10", plan: "basic" },
];

export const USERS: User[] = [
  { id: "u1", name: "Alex Rivera", email: "alex@system.com", role: "super_admin", status: "active", createdAt: "2024-01-01" },
  { id: "u2", name: "Sarah Chen", email: "sarah@techcorp.com", role: "org_admin", orgId: "o1", status: "active", createdAt: "2024-02-10" },
  { id: "u3", name: "James Wilson", email: "james@techcorp.com", role: "candidate", orgId: "o1", status: "active", createdAt: "2024-03-05" },
  { id: "u4", name: "Priya Patel", email: "priya@globalhr.com", role: "org_admin", orgId: "o2", status: "active", createdAt: "2024-04-01" },
  { id: "u5", name: "Michael Zhang", email: "mzhang@techcorp.com", role: "candidate", orgId: "o1", status: "active", createdAt: "2024-05-12" },
  { id: "u6", name: "Emma Thompson", email: "emma@techcorp.com", role: "candidate", orgId: "o1", status: "inactive", createdAt: "2024-06-01" },
  { id: "u7", name: "Liam O'Brien", email: "liam@globalhr.com", role: "candidate", orgId: "o2", status: "active", createdAt: "2024-07-11" },
  { id: "u8", name: "Nisha Sharma", email: "nisha@globalhr.com", role: "candidate", orgId: "o2", status: "active", createdAt: "2024-08-20" },
];

const LIKERT_OPTIONS = [
  { id: "l1", label: "Strongly Disagree", value: 1 },
  { id: "l2", label: "Disagree", value: 2 },
  { id: "l3", label: "Neutral", value: 3 },
  { id: "l4", label: "Agree", value: 4 },
  { id: "l5", label: "Strongly Agree", value: 5 },
];

export const QUESTION_BANKS: QuestionBank[] = [
  
];

// ─── Questions (Updated with all required fields) ───────────────────────────
// src/data/staticData.ts - Remove textTranslations field

// src/data/staticData.ts
// Add QUESTIONS to the exports

export const QUESTIONS = [
  {
    id: "q1",
    bankId: "bank1",
    text: "I like meeting new people.",
    type: "likert",
    category: "behavioral" as const,
    sectionId: "s4",
    traitId: "t1",
    traitName: "Extraversion",
    scaleId: "scale_likert_5",
    scaleType: "likert",
    weightage: 1,
    isReverse: false,
    maxScale: 5,
    difficulty: "medium" as const,
    language: "en",
    points: 1,
    status: "active" as const,
    createdBy: "system",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    order: 1
  },
  {
    id: "q2",
    bankId: "bank1",
    text: "I prefer to stay alone most of the time.",
    type: "likert",
    category: "behavioral" as const,
    sectionId: "s4",
    traitId: "t1",
    traitName: "Extraversion",
    scaleId: "scale_likert_5",
    scaleType: "likert",
    weightage: 1,
    isReverse: true,
    maxScale: 5,
    difficulty: "medium" as const,
    language: "en",
    points: 1,
    status: "active" as const,
    createdBy: "system",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    order: 2
  }
];

// ─── Sections (Updated with all required fields) ───────────────────────────
export const SECTIONS: Section[] = [
];

export const EXAMS: Exam[] = [
  {
    id: "e1",
    orgId: "o1",
    title: "Graduate Aptitude Test 2025",
    description: "Comprehensive aptitude test for fresh graduates",
    type: "aptitude",
    status: "active",
    duration: 90,
    sections: ["s1", "s2", "s3"],
    totalQuestions: 40,
    totalWeightage: 100,
    negativeMarking: true,
    negativeValue: 0.25,
    randomOrder: true,
    createdAt: "2024-11-01",
    assignedCount: 120
  },
  {
    id: "e2",
    orgId: "o1",
    title: "Leadership Psychometric Battery",
    description: "Big Five personality assessment for leadership roles",
    type: "behavioral",
    status: "active",
    duration: 45,
    sections: ["s4"],
    totalQuestions: 50,
    totalWeightage: 100,
    negativeMarking: false,
    negativeValue: 0,
    randomOrder: false,
    createdAt: "2024-11-15",
    assignedCount: 80
  },
  {
    id: "e3",
    orgId: "o2",
    title: "HR Competency Assessment",
    description: "Behavioural and situational judgement test",
    type: "situational",
    status: "draft",
    duration: 60,
    sections: [],
    totalQuestions: 30,
    totalWeightage: 100,
    negativeMarking: false,
    negativeValue: 0,
    randomOrder: true,
    createdAt: "2024-12-01",
    assignedCount: 0
  },
  {
    id: "e4",
    orgId: "o1",
    title: "IQ & Logical Reasoning Test",
    description: "Advanced IQ and logical reasoning battery",
    type: "iq",
    status: "active",
    duration: 60,
    sections: ["s2"],
    totalQuestions: 25,
    totalWeightage: 100,
    negativeMarking: false,
    negativeValue: 0,
    randomOrder: true,
    createdAt: "2024-12-10",
    assignedCount: 45
  }
];

export const ASSIGNMENTS: ExamAssignment[] = [
  {
    id: "a1",
    examId: "e2",
    candidateId: "u3",
    orgId: "o1",
    status: "completed",
    assignedAt: "2024-12-01",
    startedAt: "2024-12-08",
    completedAt: "2024-12-10"
  },
  {
    id: "a2",
    examId: "e1",
    candidateId: "u3",
    orgId: "o1",
    status: "completed",
    assignedAt: "2024-12-10",
    startedAt: "2024-12-14",
    completedAt: "2024-12-15"
  },
  {
    id: "a3",
    examId: "e1",
    candidateId: "u5",
    orgId: "o1",
    status: "in_progress",
    assignedAt: "2024-12-18",
    startedAt: "2024-12-20"
  },
  {
    id: "a4",
    examId: "e2",
    candidateId: "u5",
    orgId: "o1",
    status: "pending",
    assignedAt: "2024-12-21"
  },
  {
    id: "a5",
    examId: "e3",
    candidateId: "u7",
    orgId: "o2",
    status: "pending",
    assignedAt: "2024-12-22"
  },
  {
    id: "a6",
    examId: "e4",
    candidateId: "u3",
    orgId: "o1",
    status: "pending",
    assignedAt: "2024-12-23"
  }
];

export const RESULTS: ExamResult[] = [
  {
    id: "r1",
    assignmentId: "a1",
    candidateId: "u3",
    examId: "e2",
    orgId: "org1",
    totalScore: 165,
    maxScore: 250,
    percentage: 66,
    traitScores: [],
    completedAt: "2024-12-10",
    timeSpent: 85,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: "r2",
    assignmentId: "a2",
    candidateId: "u3",
    examId: "e1",
    orgId: "org1",
    totalScore: 28,
    maxScore: 40,
    percentage: 70,
    sectionScores: [],
    completedAt: "2024-12-15",
    timeSpent: 85,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  }
];
